import React, { Fragment } from 'react';

import Header from '../components/header';
import Footer from '../components/footer';
import Login from '../components/signin';
import Register from '../components/signup';

const Auth = (props) => {
  return (
    <Fragment>
      <Header />
        <section className="column">
          <div className="login">
            <Login />
          </div>
          <div className="register">
            <Register />
          </div>
        </section>
      <Footer />
    </Fragment>
  )
}

export default Auth;